// extracted by mini-css-extract-plugin
export default {"container":"file_container__Kgs8j","previewMedia":"file_previewMedia__4s4va"};